import React from 'react';

import Emojicon from 'components/generic/Emojicon.component';
import Space from 'components/generic/Space.component';
import { BackToLoginButton } from 'components/menu/SidebarFooter.component';
import S from 'constants/string.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './NoAccessPanel.module.scss';

const RENDERED_TEMPORARY_UNAVAILABLE = (
  <>
    <p>
      <Emojicon description="warning" value={S.waitTriangle} />
    </p>
    <p>
      <Space>Sorry, access to Slick is temporarily unavailable.</Space>
    </p>
    <p>
      <Space>Please try again later.</Space>
    </p>
    <p>
      <Emojicon description="raised hands" value={S.recycle} />
    </p>
  </>
);

const RENDERED_NO_ACCOUNTS = (
  <>
    <p>
      <Space>Oh dear! It seems you don’t have access to any Slick accounts</Space>
      <Emojicon description="thinking face" value={S.thinking} />
    </p>

    <p>
      <Space>
        Don’t worry, this is easy to resolve! Please contact customer support via live chat who can help you get the
        access you need
      </Space>
      <Emojicon description="raised hands" value={S.raisedHands} />
    </p>
  </>
);

const NoAccessPanel = ({ children, tag: tagFromProps }) => {
  const tag = fromAnyToTrimmed(tagFromProps);

  return (
    <div data-bem="NoAccessPanel" data-tag={tag} className={CN.container}>
      <div data-bem="NoAccessPanel__background" data-tag={tag} className={CN.bgr}>
        <div data-bem="NoAccessPanel__inner" data-tag={tag} className={CN.inner}>
          {children}
          <BackToLoginButton />
        </div>
      </div>
    </div>
  );
};

export const NoAccessDueToErrorPanel = () => (
  <NoAccessPanel tag="NoAccessDueToErrorPanel">{RENDERED_TEMPORARY_UNAVAILABLE}</NoAccessPanel>
);

export const NoAccessDueToListPanel = () => (
  <NoAccessPanel tag="NoAccessDueToListPanel">{RENDERED_NO_ACCOUNTS}</NoAccessPanel>
);

export const NoAccessLandingPanel = () => (
  <NoAccessPanel tag="NoAccessLandingPanel">{RENDERED_NO_ACCOUNTS}</NoAccessPanel>
);
